const translation = {
  toVerifiedTip: {
    coupon: 'mã giảm giá độc quyền 100%',
    front: 'Bạn hiện đủ điều kiện để có trạng thái Xác minh Giáo dục. Vui lòng nhập thông tin giáo dục của bạn bên dưới để hoàn tất quá trình và nhận một',
    end: 'cho Kế hoạch Chuyên nghiệp Dify.',
  },
  form: {
    schoolName: {
      placeholder: 'Nhập tên chính thức, không viết tắt của trường bạn',
      title: 'Tên Trường Của Bạn',
    },
    schoolRole: {
      option: {
        teacher: 'Giáo viên',
        student: 'Học sinh',
        administrator: 'Quản trị viên trường học',
      },
      title: 'Vai trò của bạn ở trường',
    },
    terms: {
      desc: {
        termsOfService: 'Điều khoản dịch vụ',
        privacyPolicy: 'Chính sách bảo mật',
        and: 'và',
        end: 'Bằng cách gửi:',
        front: 'Thông tin của bạn và việc sử dụng trạng thái Được xác minh Giáo dục của chúng tôi thuộc về điều kiện của chúng tôi',
      },
      option: {
        age: 'Tôi xác nhận rằng tôi ít nhất 18 tuổi',
        inSchool: 'Tôi xác nhận rằng tôi đã đăng ký hoặc làm việc tại cơ sở đã cung cấp. Dify có thể yêu cầu chứng minh về việc đăng ký/làm việc. Nếu tôi cung cấp thông tin không chính xác về đủ điều kiện của mình, tôi đồng ý trả bất kỳ khoản phí nào ban đầu được miễn dựa trên tình trạng giáo dục của tôi.',
      },
      title: 'Điều khoản & Thỏa thuận',
    },
  },
  toVerified: 'Xác thực giáo dục',
  successTitle: 'Bạn đã được xác minh giáo dục Dify',
  submit: 'Gửi',
  rejectTitle: 'Yêu cầu xác minh giáo dục Dify của bạn đã bị từ chối',
  successContent: 'Chúng tôi đã phát hành một phiếu giảm giá 100% cho gói Dify Professional vào tài khoản của bạn. Phiếu giảm giá có hiệu lực trong một năm, vui lòng sử dụng nó trong thời gian hiệu lực.',
  currentSigned: 'HIỆN ĐANG ĐĂNG NHẬP VÀO',
  learn: 'Học cách xác minh trình độ giáo dục',
  emailLabel: 'Email hiện tại của bạn',
  rejectContent: 'Rất tiếc, bạn không đủ điều kiện để nhận trạng thái Xác minh Giáo dục và do đó không thể nhận được mã giảm giá độc quyền 100% cho Kế hoạch Chuyên nghiệp Dify nếu bạn sử dụng địa chỉ email này.',
  submitError: 'Gửi mẫu không thành công. Vui lòng thử lại sau.',
}

export default translation
